import { Record, List } from "immutable";
import {
  estimateComparisonLinkFromJSON,
  IEstimateComparisonLinkData,
  EstimateComparisonLinkRecord,
} from "common/records/EstimateComparisonLink";
import { DateStringNumber, Nullable } from "common/records";
import { checkDate } from "common/helpers/Date";

export const estimateComparisonFromJSON = (json: Partial<IEstimateComparisonData>): EstimateComparisonRecord => {
  const record: IEstimateComparisonRecord = { ...(json as any) };
  if (json.estimate_comparison_links) {
    record.estimate_comparison_links = List(
      json.estimate_comparison_links.map((ecl) => estimateComparisonLinkFromJSON(ecl)),
    );
  }
  if (json.created_at) {
    record.created_at = checkDate(json.created_at);
  }

  if (json.updated_at) {
    record.updated_at = checkDate(json.updated_at);
  }

  return new EstimateComparisonRecord(record);
};

export const toJSON = (ec: EstimateComparisonRecord): IEstimateComparisonData => {
  return ec.toJS();
};

export interface IEstimateComparisonData {
  id: number;
  job_id: number;
  estimate_comparison_links: IEstimateComparisonLinkData[];
  loading: boolean;
  created_at: DateStringNumber;
  updated_at: DateStringNumber;
}

export interface IEstimateComparisonRecord {
  id: number;
  job_id: number;
  estimate_comparison_links: List<EstimateComparisonLinkRecord>;
  loading: boolean;
  created_at: Nullable<Date>;
  updated_at: Nullable<Date>;
}

export const defaultEstimateComparisonProps: IEstimateComparisonRecord = {
  id: 0,
  job_id: -1,
  estimate_comparison_links: List<EstimateComparisonLinkRecord>(),
  loading: false,
  created_at: null,
  updated_at: null,
};

export class EstimateComparisonRecord
  extends Record(defaultEstimateComparisonProps)
  implements IEstimateComparisonRecord {}
